import { DiaryAnalyticsService } from 'src/app/data/repository/analytics-repository/diary-analytics.service';
import { BottomsheetShared } from './../../../general/shared/bottomsheet-shared';
import { ExerciseService } from './../../../../data/repository/plan-repository/exercise.service';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subscription, Subject } from 'rxjs';
import { PlanService } from 'src/app/data/repository/plan-repository/plan.service';
import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { ExerciseItem } from '../../../../core/model/api-response/plans-response-model';
import { ExerciseLogService } from './../../../../data/repository/plan-repository/exercise-log.service';

@Component({
  selector: 'app-exercises',
  templateUrl: './exercises.component.html',
  styleUrls: ['./exercises.component.scss'],
})
export class ExercisesComponent implements OnInit, OnDestroy {
  searchText: string;
  subscriptions: Subscription[] = [];
  txtQueryChanged: Subject<string> = new Subject<string>();
  isFocuse: boolean = false;
  exercises: ExerciseItem[];
  customeExrecise: boolean = false;
  type: string;
  history: ExerciseItem[];
  showHistory: boolean = false;
  query: string = '';
  date: number;

  constructor(
    private planService: PlanService,
    private exerciseService: ExerciseService,
    private bottomsheetShared: BottomsheetShared,
    private diaryAnalytics: DiaryAnalyticsService,
    private exerciseLogService: ExerciseLogService
  ) {
    const txtq = this.txtQueryChanged
      .pipe(debounceTime(800), distinctUntilChanged())
      .subscribe((data) => {
        this.isFocuse = true;
        this.getExercises(data);
      });
    const bottomSheet = this.bottomsheetShared.closeBottomsheetObs$.subscribe(
      (close) => {
        if (close) {
          this.customeExrecise = false;
        }
      }
    );
    this.date = this.exerciseLogService.CDate;
    this.bottomsheetShared.CDate = this.date;

    this.subscriptions.push(bottomSheet, txtq);
  }

  ngOnInit() {
    this.diaryAnalytics.analyticDiaryAddActivityVisited();

    this.history = this.exerciseService.getHistory();
    if (this.history) {
      this.showHistory = true;
    }
  }
  openCustomeExercise() {
    this.customeExrecise = true;
    this.bottomsheetShared.CDate = this.date;

    this.type = 'cutome-exercise';
  }
  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscriptions.forEach((sb) => sb.unsubscribe());
  }
  openExercise(item: ExerciseItem, history?: boolean) {
    if (history) {
      this.bottomsheetShared.SearchHistoryExercise = true;
    }
    this.bottomsheetShared.met = item.met;
    this.bottomsheetShared.exerciseTitle = item.name;
    this.bottomsheetShared.exerciseItem = item;
    this.bottomsheetShared.CDate = this.date;
    this.type = 'exercise';
    this.customeExrecise = true;
    this.exerciseService.addTohistory(item);
  }
  back() {
    this.planService.goBack();
  }
  getExercises(query: string) {
    this.exerciseService.searchExercise(query).then((res) => {
      this.exercises = res.getData().getExerciseSearch().exercises;
    });
  }
  search(query: string) {
    query = query.trim();
    this.query = query;
    if (query.length <= 0 || query === '') {
      this.isFocuse = false;
      this.exercises = [];
      this.showHistory = true;
    } else {
      this.diaryAnalytics.analyticDiarySearchActivityVisited();

      this.showHistory = false;
      this.isFocuse = true;

      this.txtQueryChanged.next(query);
    }
  }
  onkeydown(e: KeyboardEvent) {
    if ((e.key == 'Backspace' && this.query.length <= 0) || this.query === '') {
      this.isFocuse = false;
      this.showHistory = false;
    }
  }

  openHistory() {
    this.isFocuse = true;
    this.showHistory = true;
  }
  onBlur() {
    this.isFocuse = false;
  }
  removeExercise(e: ExerciseItem) {
    this.exerciseService.removeHistory(e);
    this.history = this.exerciseService.getHistory();
    if (this.history) {
      this.showHistory = true;
    }
  }
}
